export default __webpack_public_path__ + "static/media/gallery-crosssells1.d056f275.png";